var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Box, Divider, IconButton, InputBase, Stack, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import { FORM_FIELD_TOKENS, WIZARD_COLORS, } from '../../../components/FormComponents/dynamicForm';
import { addApplicationComment, fetchApplicationComments, formatCommentTime, parseCommentSender, } from '../application_comment_service';
var inputSx = {
    width: '100%',
    fontSize: 13,
    padding: '8px 12px',
    borderRadius: FORM_FIELD_TOKENS.radius,
    border: "1px solid ".concat(FORM_FIELD_TOKENS.borderColor),
    backgroundColor: FORM_FIELD_TOKENS.surfaceColor,
    '&.Mui-focused': { borderColor: FORM_FIELD_TOKENS.accentColor },
};
var SUBJECT_MAX_LENGTH = 50;
var MESSAGE_MAX_LENGTH = 2000;
var NO_NOTES_TEXT = 'No notes yet.';
var ApplicationNotesPanel = function (_a) {
    var commentContext = _a.commentContext, getCustomerName = _a.getCustomerName, onDraftApplicationId = _a.onDraftApplicationId;
    var _b = React.useState([]), comments = _b[0], setComments = _b[1];
    var _c = React.useState(''), subject = _c[0], setSubject = _c[1];
    var _d = React.useState(''), message = _d[0], setMessage = _d[1];
    var _e = React.useState(false), isSending = _e[0], setIsSending = _e[1];
    var _f = commentContext.applicationId, applicationId = _f === void 0 ? '' : _f, _g = commentContext.txAspireOId, txAspireOId = _g === void 0 ? '' : _g;
    var contextRef = React.useRef(commentContext);
    contextRef.current = __assign(__assign({}, commentContext), { applicationId: commentContext.applicationId || contextRef.current.applicationId });
    var loadComments = React.useCallback(function (nextApplicationId, nextTxAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var notes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchApplicationComments(nextApplicationId, nextTxAspireOId)];
                case 1:
                    notes = _a.sent();
                    setComments(notes);
                    return [2];
            }
        });
    }); }, []);
    React.useEffect(function () {
        if (applicationId || txAspireOId) {
            loadComments(applicationId, txAspireOId);
        }
    }, [applicationId, loadComments, txAspireOId]);
    var canSend = message.trim().length > 0 && !isSending;
    var handleSend = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!canSend) {
                        return [2];
                    }
                    setIsSending(true);
                    return [4, addApplicationComment(contextRef.current, {
                            subject: subject.trim(),
                            text: message.trim(),
                            customerName: getCustomerName(),
                        })];
                case 1:
                    result = _a.sent();
                    setIsSending(false);
                    if (!result.isSuccess) {
                        return [2];
                    }
                    setSubject('');
                    setMessage('');
                    if (result.applicationId) {
                        contextRef.current = __assign(__assign({}, contextRef.current), { applicationId: result.applicationId });
                        onDraftApplicationId(result.applicationId);
                    }
                    loadComments(result.applicationId || contextRef.current.applicationId || '', contextRef.current.txAspireOId || '');
                    return [2];
            }
        });
    }); }, [canSend, getCustomerName, loadComments, message, onDraftApplicationId, subject]);
    return (React.createElement(Box, { component: "aside", "aria-label": "Notes for the finance team", sx: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: FORM_FIELD_TOKENS.surfaceColor,
            border: "1px solid ".concat(FORM_FIELD_TOKENS.sectionBorderColor),
            borderRadius: '8px',
            padding: '14px',
            minHeight: 360,
        } },
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
            React.createElement(StickyNote2OutlinedIcon, { sx: { fontSize: 18, color: WIZARD_COLORS.body } }),
            React.createElement(Typography, { sx: { fontSize: 15, fontWeight: 700, color: WIZARD_COLORS.ink } }, "Notes")),
        React.createElement(Typography, { sx: { fontSize: 12, color: WIZARD_COLORS.label, mt: 0.25 } }, "Send Notes to Finance Team related to the contract"),
        React.createElement(Box, { sx: { flex: 1, minHeight: 120, mt: 2, overflowY: 'auto' } }, comments.length === 0 ? (React.createElement(Typography, { sx: { fontSize: 13, color: WIZARD_COLORS.label } }, NO_NOTES_TEXT)) : (comments.map(function (comment, commentIndex) {
            var _a = parseCommentSender(comment.commentedBy), name = _a.name, role = _a.role;
            var commentedAt = formatCommentTime(comment.createdTime);
            return (React.createElement(Box, { key: "".concat(comment.createdTime, "-").concat(commentIndex), sx: { mb: 1.5 } },
                React.createElement(Box, { sx: {
                        borderRadius: '6px',
                        backgroundColor: WIZARD_COLORS.section,
                        border: "1px solid ".concat(FORM_FIELD_TOKENS.sectionBorderColor),
                        padding: '8px 10px',
                    } },
                    Boolean(name) && (React.createElement(React.Fragment, null,
                        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75, sx: { mb: 0.75 } },
                            React.createElement(PersonOutlineOutlinedIcon, { "aria-hidden": true, sx: {
                                    fontSize: 18,
                                    color: WIZARD_COLORS.muted,
                                } }),
                            React.createElement(Typography, { sx: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: WIZARD_COLORS.ink,
                                } },
                                name,
                                Boolean(role) && (React.createElement(Box, { component: "span", sx: {
                                        fontStyle: 'italic',
                                        fontWeight: 400,
                                    } }, " (".concat(role, ")"))))),
                        React.createElement(Divider, { sx: {
                                borderColor: WIZARD_COLORS.border,
                                mb: 0.75,
                            } }))),
                    Boolean(comment.subject) && (React.createElement(Typography, { sx: {
                            fontSize: 13,
                            fontWeight: 700,
                            color: WIZARD_COLORS.ink,
                            wordBreak: 'break-word',
                        } }, comment.subject)),
                    React.createElement(Typography, { sx: {
                            fontSize: 13,
                            color: WIZARD_COLORS.body,
                            wordBreak: 'break-word',
                        } }, comment.text)),
                Boolean(commentedAt) && (React.createElement(Typography, { sx: {
                        fontSize: 11,
                        color: WIZARD_COLORS.label,
                        mt: 0.5,
                    } }, commentedAt))));
        }))),
        React.createElement(Box, { sx: { mt: 2 } },
            React.createElement(InputBase, { value: subject, onChange: function (event) { return setSubject(event.target.value); }, placeholder: "Enter your Subject here...", inputProps: { 'aria-label': 'Note subject', maxLength: SUBJECT_MAX_LENGTH }, sx: inputSx }),
            React.createElement(Box, { sx: { position: 'relative', mt: 1 } },
                React.createElement(InputBase, { multiline: true, minRows: 3, value: message, onChange: function (event) { return setMessage(event.target.value); }, onKeyDown: function (event) {
                        if (event.key === 'Enter' && !event.shiftKey) {
                            event.preventDefault();
                            handleSend();
                        }
                    }, placeholder: "Type your message here...", inputProps: {
                        'aria-label': 'Note message',
                        maxLength: MESSAGE_MAX_LENGTH,
                    }, sx: __assign(__assign({}, inputSx), { paddingBottom: '44px' }) }),
                React.createElement(IconButton, { "aria-label": "Send note", disabled: !canSend, onClick: handleSend, sx: {
                        position: 'absolute',
                        right: 8,
                        bottom: 8,
                        width: 30,
                        height: 30,
                        borderRadius: '6px',
                        color: WIZARD_COLORS.surface,
                        backgroundColor: FORM_FIELD_TOKENS.actionColor,
                        '&:hover': { backgroundColor: '#2B2C33' },
                        '&.Mui-disabled': {
                            backgroundColor: WIZARD_COLORS.pending,
                            color: WIZARD_COLORS.surface,
                        },
                    } },
                    React.createElement(ArrowForwardIcon, { sx: { fontSize: 16 } }))))));
};
export default React.memo(ApplicationNotesPanel);
